module.exports = __webpack_public_path__ + "static/lemonanimal3-1f619643dfe8d891d97ba28fc62759c4.png";